import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
export function CountdownPricing() {
  return <section id="pricing" className="py-20 relative bg-brand-cream" data-id="element-52">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-53">
        <FadeIn className="text-center mb-12" data-id="element-54">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-accent leading-tight" data-id="element-55">
            Si llegaste hasta acá... el MEGAPACK EDICIÓN COMPLETA es para vos 👇
          </h2>
        </FadeIn>

        <div className="max-w-2xl mx-auto" data-id="element-56">
          <FadeIn delay={0.2} data-id="element-57">
            <div className="bg-brand-card border-2 border-brand-accent rounded-3xl p-8 flex flex-col relative shadow-lg" data-id="element-58">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-terracotta text-white font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider" data-id="element-59">
                Más Elegida ⭐
              </div>

              <div className="mb-6" data-id="element-60">
                <h3 className="text-2xl font-bold text-brand-dark mb-2" data-id="element-61">
                  🏆 MEGAPACK PREMIUM
                </h3>
                <p className="text-brand-terracotta font-medium mb-4" data-id="element-62">
                  HINCHADA, CANSADA Y NERVIOSA
                </p>
                <p className="text-brand-muted text-sm mb-4" data-id="element-63">
                  3 Tomos + 3 Checklists + Kit Completo de Acción
                </p>

                <div className="space-y-2 mb-6" data-id="element-64">
                  <div className="flex items-start gap-2 text-sm" data-id="element-65">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-66" />
                    <span data-id="element-67">📘 Tomo 1: Adiós a la Hinchazón (20 pág)</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-68">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-69" />
                    <span data-id="element-70">📗 Tomo 2: Paz en Dos Minutos (20 pág)</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-71">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-72" />
                    <span data-id="element-73">📙 Tomo 3: Energía Real (20 pág)</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-74">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-75" />
                    <span data-id="element-76">✅ Checklist de 72hs (imprimible)</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-77">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-78" />
                    <span data-id="element-79">✅ Rastreador de síntomas semanal</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-80">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-81" />
                    <span data-id="element-82">✅ Guía de sustituciones rápidas</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-83">
                    <CheckCircle2 className="w-4 h-4 text-brand-terracotta shrink-0 mt-0.5" data-id="element-84" />
                    <span className="font-medium" data-id="element-85">
                      🎁 BONO 1: Lista de compras SOS (menos de $3.000 ARS)
                    </span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-86">
                    <CheckCircle2 className="w-4 h-4 text-brand-terracotta shrink-0 mt-0.5" data-id="element-87" />
                    <span className="font-medium" data-id="element-88">
                      🎁 BONO 2: Guía de suplementación con precios ARS
                      actualizados
                    </span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-89">
                    <CheckCircle2 className="w-4 h-4 text-brand-terracotta shrink-0 mt-0.5" data-id="element-90" />
                    <span className="font-medium" data-id="element-91">
                      🎁 BONO 3: Plan de 21 días integrado (los 3 sistemas
                      juntos)
                    </span>
                  </div>
                </div>
              </div>

              <div className="mb-8 bg-brand-cream border border-brand-accent rounded-xl p-4" data-id="element-92">
                <div className="text-[#AAAAAA] line-through text-lg mb-1" data-id="element-93">
                  $51.000
                </div>
                <div className="text-5xl font-bold text-brand-accent flex items-baseline gap-1" data-id="element-94">
                  $27.990{' '}
                  <span className="text-lg text-brand-muted font-normal" data-id="element-95">
                    ARS
                  </span>
                </div>
              </div>

              <div className="mt-auto" data-id="element-96">
                <Button href="https://librofy-store.myshopify.com/checkouts/cn/hWNC5cbir52UeAwo3A3qwXxa/es-ar?_r=AQABhtZPXaHDGptiLQeN1ak6QL0ngChxC8r-RkPbDgyNOUg" fullWidth size="xl" variant="terracotta" className="mb-4" data-id="element-97">
                  → QUIERO EL MEGAPACK PREMIUM ⭐
                </Button>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}